import React from "react";
import styled from 'styled-components';

const HeroContainer = styled.div`
width: 100%;
min-height: ${props => props.h };
background: linear-gradient( rgba(0, 0, 0, ${props => props.darken}), rgba(0, 0, 0, ${props => props.darken}) ), 
url(${props => props.source});
background-repeat: no-repeat;
background-size: cover;
background-position: center;
padding: 0 .75rem 0 .75rem;
overflow-y: hidden;
//border: 20px solid #fff;
`

const Hero = (props) => {


  return (
    <HeroContainer {...props}>
      {props.children}
    </HeroContainer>
  )

}

export default Hero;